import { render, staticRenderFns } from "./goodsManageLayout.vue?vue&type=template&id=30e20338&scoped=true&"
import script from "./goodsManageLayout.vue?vue&type=script&lang=js&"
export * from "./goodsManageLayout.vue?vue&type=script&lang=js&"
import style0 from "./goodsManageLayout.vue?vue&type=style&index=0&id=30e20338&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e20338",
  null
  
)

export default component.exports